import Alpine, { AlpineComponent } from 'alpinejs';
import { iodine } from '../../helpers/validation';
import './filleuls';
import './styles.pcss';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';

interface ParrainageFormAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    form: HTMLFormElement;
    errorMessages: { [key in string]: string }[];
}

const rules = {
    civility: ['truthy'],
    recommendedProducts: ['truthy'],
    firstname: ['required'],
    lastname: ['required'],
    address: ['required'],
    zip: ['required'],
    city: ['required'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initFormValidation', (form: HTMLFormElement): ParrainageFormAlpine & FormFieldValidationAlpine => {
        return {
            ...getFieldValidation(rules),
            ...{
                form,
                validate(): void {
                    this.errorMessages = [];
                    const firstname = this.$refs.firstname as HTMLInputElement;
                    const lastname = this.$refs.lastname as HTMLInputElement;
                    const address = this.$refs.address as HTMLInputElement;
                    // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
                    const zip = document.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const city = this.$refs.city as HTMLInputElement;
                    const phone = this.$refs.phone as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    const civilityMadam = this.$refs.civility_madam as HTMLInputElement;
                    const civilitySir = this.$refs.civility_sir as HTMLInputElement;
                    const recommendedProductsChecked = Array.from(document.querySelectorAll<HTMLInputElement>('[name*="recommendedProducts"][type=checkbox]')).some((el) => el.checked);

                    const contactItems = {
                        firstname: firstname.value,
                        lastname: lastname.value,
                        address: address.value,
                        zip: zip.value,
                        city: city.value,
                        phone: phone.value,
                        email: email.value,
                        civility: civilityMadam.checked || civilitySir.checked,
                        recommendedProducts: recommendedProductsChecked,
                    };

                    const contactRules = {
                        firstname: rules.firstname,
                        lastname: rules.lastname,
                        address: rules.address,
                        zip: rules.zip,
                        city: rules.city,
                        phone: rules.phone,
                        email: rules.email,
                        civility: rules.civility,
                        recommendedProducts: rules.recommendedProducts,
                    };

                    const validation = iodine.assert(contactItems, contactRules);

                    const submitButton = form.querySelector('button[type=submit]') as HTMLButtonElement;
                    if (validation.valid) {
                        submitButton.disabled = true;
                        form.submit();
                    } else {
                        submitButton.disabled = false;
                        this.displayErrors(validation);
                    }
                },
            },
        };
    });
});
